import moment from "moment"
import React from "react"
import { getModuleicon } from "utils/common-helpers"
import indiaFlag from "../../../assets/images/flags/india.png"
import ukFlag from "../../../assets/images/flags/uk.png"
import { Link } from "react-router-dom"
import configure from "configure"

export const leaveColumns = onLeaveDetail => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Employee Name",
    accessor: "name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-3",
  },
  {
    Header: "Applied On",
    accessor: "created_at",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lapplied_on_box",
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original.created_at).format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Reason",
    accessor: "leave_reason",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lreason_box text-start",
  },
  {
    Header: "Leave Date",
    accessor: "start_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
    Cell: cellProps => {
      const { start_date, end_date } = cellProps?.row?.original || {}
      const start = start_date ? moment(start_date).format("DD-MM-YYYY") : null
      const end = end_date ? moment(end_date).format("DD-MM-YYYY") : null
      if (!start && !end) return <div>-</div>
      return <div>{start && end && start !== end ? `${start} - ${end}` : start || end}</div>
    },
  },
  {
    Header: "Total Days",
    accessor: "leave_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },

  {
    Header: "Action",
    accessor: "action",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          <a
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
            onClick={() =>
              onLeaveDetail(
                cellProps?.row?.original?.id,
                cellProps?.row?.original?.employee,
                cellProps?.row?.original
              )
            }
          >
            <i className="fas fa-eye "></i>
          </a>
        </div>
      )
    },
  },
]

export const searchColumns = getNotes => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    Cell: cellProps => {
      const location = cellProps?.row?.original?.location
      const data = cellProps.row.original
      const mainLocation =
        data?.tableName == "tblleads"
          ? data?.lead_belongs_to
          : data?.tableName == "tblcustomer" ||
            data?.tableName == "tbllead_potential" ||
            data?.tableName == "tblproposal" ||
            data?.tableName == "tblcontract" ||
            data?.tableName == "zithas_technology_invoice" ||
            data?.tableName == "tblinvoice" ||
            data?.tableName == "tblgeneraltask"
          ? data?.location
          : data?.tableName == "tblintroducer"
          ? data?.leadbelogto
          : data?.tableName == "tblprojects"
          ? data?.projectbelogsto
          : 0
      return (
        <div className="d-flex align-items-center">
          {mainLocation != 0 ? (
            <img
              src={mainLocation == "1" ? indiaFlag : ukFlag}
              value={location}
              className=" me-3"
              width="25"
              height="15"
              alt="flag"
            />
          ) : null}

          {cellProps?.row?.original?.id}
        </div>
      )
    },
  },
  {
    Header: "Subject",
    accessor: "title",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-10",
    Cell: cellProps => {
      const data = cellProps.row.original
      const text =
        data?.tableName == "tblleads" ||
        data?.tableName == "tblcustomer" ||
        data?.tableName == "tblintroducer" ||
        data?.tableName == "tblopportunity"
          ? data?.company
          : data?.tableName == "tbllead_potential" ||
            data?.tableName == "tblopportunity_contact"
          ? data?.name
          : data?.tableName == "tblproposal"
          ? data?.proposaltitile
          : data?.tableName == "tblcontract"
          ? data?.service
          : data?.tableName == "tblcustomer_notes" ||
            data?.tableName == "tblproject_note" ||
            data?.tableName == "tbllead_notes" ||
            data?.tableName == "tblopportunity_notes" ||
            data?.tableName == "tbllead_followup" ||
            data?.tableName == "tblopportunity_followup"
          ? data?.description?.slice(0, 50)
          : data?.tableName == "tblopportunity_history"
          ? data?.file_name
          : data?.tableName == "zithas_technology_invoice" ||
            data?.tableName == "tblinvoice"
          ? data?.invoice_number
          : data?.tableName == "tblprojects"
          ? data?.project_name
          : data?.tableName == "tblgeneraltask"
          ? data?.title
          : data?.tableName == "tblsupport"
          ? data?.subject
          : ""

      const SubModule =
        data?.tableName == "tblleads"
          ? "Leads"
          : data?.tableName == "tblcustomer"
          ? "Customer"
          : data?.tableName == "tblintroducer"
          ? "Introducer"
          : data?.tableName == "tblopportunity" ||
            data?.tableName == "tblopportunity_contact" ||
            data?.tableName == "tblopportunity_history"
          ? "Oppurtunity"
          : data?.tableName == "tbllead_potential"
          ? "Lead Potential"
          : data?.tableName == "tblproposal"
          ? "Proposal"
          : data?.tableName == "tblcontract"
          ? "Contract"
          : data?.tableName == "tblcustomer_notes"
          ? "Customer Notes"
          : data?.tableName == "tblproject_note"
          ? "Project Notes"
          : data?.tableName == "tbllead_notes"
          ? "Lead Notes"
          : data?.tableName == "tblopportunity_notes"
          ? "Opportunity Notes"
          : data?.tableName == "tbllead_followup"
          ? "Lead Followup"
          : data?.tableName == "tblopportunity_followup"
          ? "Opportunity Followup"
          : data?.tableName == "zithas_technology_invoice"
          ? "Zithas Invoice"
          : data?.tableName == "tblinvoice"
          ? "Invoice"
          : data?.tableName == "tblprojects"
          ? "Projects"
          : data?.tableName == "tblgeneraltask"
          ? "General Task"
          : data?.tableName == "tblsupport"
          ? "Support"
          : ""
      return (
        <div className="d-flex justify-content-start gap-1 notification_box align-items-center ms-3">
          <div className="module-icon me-2">
            {getModuleicon(cellProps.row.original?.moduleName?.toLowerCase())}
          </div>
          {SubModule} - <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "leave_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-1 text-center",
    Cell: cellProps => {
      const data = cellProps.row.original
      const url =
        data?.tableName == "tblleads"
          ? `sales/edit-lead/${data?.id}`
          : data?.tableName == "tbllead_followup" ||
            data?.tableName == "tbllead_notes"
          ? `sales/edit-lead/${data?.lead_id}`
          : data?.tableName == "tblcustomer"
          ? `sales/edit-customer/${data?.customer_id}`
          : data?.tableName == "tblcustomer_notes"
          ? `sales/edit-customer/${data?.customer_id}`
          : data?.tableName == "tblintroducer"
          ? `sales/edit-introducer/${data?.id}`
          : data?.tableName == "tblcontract"
          ? `sales/edit-contract/${data?.id}`
          : data?.tableName == "tblproposal"
          ? `sales/edit-proposal/${data?.id}`
          : data?.tableName == "tblprojects"
          ? `work/edit-project/${data?.id}`
          : data?.tableName == "tblproject_note"
          ? `work/edit-project/${data?.project_id}`
          : data?.tableName == "tblsupport"
          ? `support/tickets/${data?.project_id}`
          : data?.tableName == "tblgeneraltask"
          ? `work/activities?task=${data?.id}`
          : data?.tableName == "tblopportunity" ||
            data?.tableName == "tblopportunity_notes" ||
            data?.tableName == "tblopportunity_followup" ||
            data?.tableName == "tblopportunity_history"
          ? `marketing/Getindustrydetails/${data?.project_id}`
          : "/"
      return (
        <div className="d-flex">
          <Link
            to={`${configure.appUrl}${url}`}
            target="_blank"
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
          >
            <i className="fas fa-arrow-right"></i>
          </Link>
          {data?.tableName == "tblleads" ||
          data?.tableName == "tbllead_notes" ? (
            <a
              title="add note"
              className="btn btn-sm btn-outline-secondary me-1"
              onClick={e =>
                getNotes(
                  data?.tableName == "tblleads" ? data?.id : data?.lead_id
                )
              }
            >
              <i className="fas fa-file-alt "></i>
            </a>
          ) : null}
        </div>
      )
    },
  },
]

export const credentialColumns = onGetDetail => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
  },
  {
    Header: "Tab Name",
    accessor: "tab_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-2",
  },
  {
    Header: "Subject",
    accessor: "credentials",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-10",
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.credentialColmn} -{" "}
          {cellProps?.row?.original?.credentials}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "leave_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-1 text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          <Link
            to={`${configure.appUrl}credentials?tab=${cellProps?.row?.original?.id}&credential=${cellProps?.row?.original?.credential_id}`}
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
          >
            <i className="fas fa-eye "></i>
          </Link>
        </div>
      )
    },
  },
]

export const seoReportColumns = (onViewChanges, onStatusChange) => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
  },
  {
    Header: "Project Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-10",
  },
  {
    Header: "Month",
    accessor: "report_month",
    isInfoIcon: false,
    isShortIcon: true,
    Cell: ({ value }) => moment(value, "MM").format("MMMM"),
  },
  {
    Header: "Year",
    accessor: "report_year",
    isInfoIcon: false,
    isShortIcon: true,
  },
  {
    Header: "Action",
    accessor: "action",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-1 text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          <a
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
            onClick={() => onViewChanges(cellProps?.row?.original)}
          >
            <i className="fas fa-eye "></i>
          </a>
          <a
            title="approve"
            className="btn btn-sm btn-outline-success me-1"
            onClick={() => onStatusChange(cellProps?.row?.original?.id, 1)}
          >
            <i className="fa fa-check "></i>
          </a>
          <a
            title="unapprove"
            className="btn btn-sm btn-outline-danger me-1"
            onClick={() => onStatusChange(cellProps?.row?.original?.id, 0)}
          >
            <i className="fas fa-times "></i>
          </a>
        </div>
      )
    },
  },
]
